import QuestionPage from '@app-studio-web/ui/pages/QuestionPage'
import { useTranslation } from 'react-i18next'
import { useSubmit } from 'react-router-dom'

export default function QuestionStressPage() {
  const submit = useSubmit()
  const { t } = useTranslation()

  const handleSubmit = (event: React.FormEvent<HTMLFormElement>) => {
    submit(event.currentTarget)
  }

  return (
    <QuestionPage
      heading={t('pages.onboarding.v1.questionStress.heading')}
      subheading={t('pages.onboarding.v1.questionStress.subheading')}
      buttons={[
        {
          text: t('pages.onboarding.v1.questionStress.button1'),
          value: 'very_stressed',
        },
        {
          text: t('pages.onboarding.v1.questionStress.button2'),
          value: 'moderate_stress',
        },
        {
          text: t('pages.onboarding.v1.questionStress.button3'),
          value: 'occasionally_stressed',
        },
        {
          text: t('pages.onboarding.v1.questionStress.button4'),
          value: 'pretty_relaxed',
        },
      ]}
      onSubmit={handleSubmit}
    />
  )
}
